/* eslint-disable no-restricted-imports */
import { getCreate2Address } from '@ethersproject/address';
import { keccak256, pack } from '@ethersproject/solidity';
import { FACTORY_ADDRESS, INIT_CODE_HASH } from '@sushiswap/sdk';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { ROUTER_ADDRESSES } from '../constants';
export var params = {
    input: {
        to: new FctAddress({ destination: 'sushiswap_router' }),
        methodParams: {
            tokenA: new FctAddress({ destination: 'erc20' }),
            tokenB: new FctAddress({ destination: 'erc20' }),
            liquidity: new FctValue({ destination: 'wei_amount' }),
            amountAMin: new FctValue({ destination: 'wei_amount' }),
            amountBMin: new FctValue({ destination: 'wei_amount' }),
            to: new FctAddress({}),
            deadline: new FctTimestamp({}),
        },
    },
    output: {
        amountA: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
        amountB: new FctValue({ innerIndex: 1, destination: 'wei_amount' }),
    },
};
export var RemoveLiquidity = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'removeLiquidity',
    description: 'Remove liquidity on Sushiswap',
    supportedContracts: ROUTER_ADDRESSES,
    getParams: function () { return params; },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params, chainId) {
        var token0 = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
        var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
        var getToken = function () {
            if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
                var pairAddress = getCreate2Address(FACTORY_ADDRESS[chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH[chainId]);
                return pairAddress;
            }
            return undefined;
        };
        return [
            {
                to: getToken(),
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
